import { useNavigate, useParams } from "react-router-dom";

import { Dashboard } from "@/app/dashboard/Dashboard";
import { useAppContext } from "@/app/providers/AppContext";

/**
 * JS-1060: routed shell for the daily edition + archive.
 *
 * A dedicated route (mirrors WatchCreatePortalPage) rather than the
 * `/portal/:tabId` single-segment scheme -- an edition needs a DATE in its
 * URL so a specific published edition is linkable/bookmarkable
 * (`/portal/trade-ideas/edition/:asOf`), which `/portal/:tabId` cannot
 * express. `/portal/trade-ideas/edition` with no date shows the latest
 * ("today") edition; picking an older one from the archive rail navigates to
 * its dated URL.
 *
 * JS-1094 (demo blocker FIX 1): renders INSIDE the same `Dashboard` portal
 * shell every other routed page uses (see WatchCreatePortalPage's identical
 * pattern) -- rendering the bare `EditionPage` content directly (the
 * pre-JS-1094 behavior) dropped the sidebar entirely, leaving the edition a
 * navigational dead end with no way back into the rest of the portal short
 * of the browser Back button.
 */
export default function EditionPortalPage() {
  const navigate = useNavigate();
  const { asOf } = useParams();
  const { profile, entitlements, api, loading } = useAppContext();

  return (
    <Dashboard
      tabId="trade-ideas-edition"
      profile={profile}
      entitlements={entitlements}
      loading={loading}
      api={api}
      onUpgrade={() => navigate("/portal/plans")}
      onNewWatch={() => navigate("/portal/watches/new")}
      onTabChange={(tabId) => navigate(`/portal/${tabId}`)}
      editionAsOf={asOf ?? null}
      onSelectEditionAsOf={(nextAsOf) => navigate(`/portal/trade-ideas/edition/${encodeURIComponent(nextAsOf)}`)}
    />
  );
}
